//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";

  export default {
    data() {
      return {
        pagination: {
          rowsPerPage: 6,
          page: 1,
          sortBy: "deliveryDate",
          descending: false,
        },
        dateVal: 
        {
          label: "I dag",
          fromDate: this.formatCurrentDate(),  
        },
        pickDateOptions: [
          {
            label: "I dag",
            fromDate: this.formatCurrentDate(),  
          },
          {
            label: "Denne uken",
            fromDate: this.getStartOfWeek(),  
          },
          {
            label: "Denne måneden",
            fromDate: this.getStartOfMonth(), 
          },
          {
            label: "Alle",
            fromDate: '0001-01-01T00:00:00',
          },
        ],
        deliveryPremissionData: [],
        inTimeCount: 0,
        toLateCount: 0,
        earlyCount: 0,
        columns: [
            {
              name: "orderNumber",
              align: "left",
              label: this.$t("order.orderNo"),
              field: "orderNumber",
              sortable: true,
            },
            {
              name: "customerName",
              align: "left",
              label: "Kunde navn",
              field: "customerName",
              sortable: true,
            },
            {
              name: "expectedDeliveryDate",
              align: "left",
              label: "Dato forventet",
              field: "expectedDeliveryDate",
              sortable: true,
            },
            {
              name: "deliveredDate",
              align: "left",
              label: "Dato levert",
              field: "deliveredDate",
              sortable: true,
            },
            {
              name: "dateDiff",
              align: "left",
              label: "differanse",
              field: "dateDiff",
              sortable: true,
            },
        ],
      };
    },
    async mounted() {
        await this.getDeliveryPremissionData();
    },
  
    methods: {
      ...mapActions("main", ["getDeliveryPressision"]),

      async getDeliveryPremissionData() {
        this.deliveryPremissionData = await this.getDeliveryPressision(this.dateVal);

        this.toLateCount = 0;
        this.earlyCount = 0;
        this.inTimeCount = 0;

        for(var i = 0; i < this.deliveryPremissionData.length; i++) {
          this.deliveryPremissionData[i].expectedDeliveryDate = this.formatDatePretty(this.deliveryPremissionData[i].expectedDeliveryDate);
          this.deliveryPremissionData[i].deliveredDate = this.formatDatePretty(this.deliveryPremissionData[i].deliveredDate);

          if(this.deliveryPremissionData[i].dateDiff > 0) {
            this.toLateCount++;
          }
          else if(this.deliveryPremissionData[i].dateDiff < 0) {
            this.earlyCount++;
          }
          else if(this.deliveryPremissionData[i].dateDiff == 0) {
            this.inTimeCount++;
          }
        }
      },

      formatDatePretty(inputDate) {
        const date = new Date(inputDate);

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        const formattedDate = `${day}-${month}-${year}`;

        return formattedDate;
      },

       getStartOfWeek() {
        let today = new Date();
        let dayOfWeek = today.getDay(); 

        let daysAgo = dayOfWeek;
        let startOfWeek = new Date(today);
        startOfWeek.setDate(today.getDate() - daysAgo);

        startOfWeek.setHours(0, 0, 0, 0);

        let month = startOfWeek.getMonth() + 1; 
        let formattedMonth = month < 10 ? `0${month}` : month;
        let day = startOfWeek.getDate();
        let formattedDay = day < 10 ? `0${day}` : day;

        let startOfWeekFormatted = `${startOfWeek.getFullYear()}-${formattedMonth}-${formattedDay}T00:00:00`;

        return startOfWeekFormatted;
      },

      getStartOfMonth() {
        let today = new Date();
        let startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

        startOfMonth.setHours(0, 0, 0, 0);

        let month = startOfMonth.getMonth() + 1;
        let formattedMonth = month < 10 ? `0${month}` : month;
        let day = startOfMonth.getDate();
        let formattedDay = day < 10 ? `0${day}` : day;

        let startOfMonthFormatted = `${startOfMonth.getFullYear()}-${formattedMonth}-${formattedDay}T00:00:00`;

        return startOfMonthFormatted;
      },

      formatCurrentDate() {
        let currentDate = new Date();

        let year = currentDate.getFullYear();
        let month = currentDate.getMonth() + 1; 
        let day = currentDate.getDate();
        let hours = currentDate.getHours();
        let minutes = currentDate.getMinutes();
        let seconds = currentDate.getSeconds();

        let formattedMonth = month < 10 ? `0${month}` : month;
        let formattedDay = day < 10 ? `0${day}` : day;
        let formattedHours = hours < 10 ? `0${hours}` : hours;
        let formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
        let formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

        let formattedDate = `${year}-${formattedMonth}-${formattedDay}T${formattedHours}:${formattedMinutes}:${formattedSeconds}`;

        return formattedDate;
      }
    },
  };
  